import {DeserializeConverterFunc, IPropSchema, PropSchema} from '@mintdata/mint-kit/impl/util/serializr/src/api/types';
import {_defaultPrimitiveProp} from '../constants';
import {invariant, isAliasedPropSchema, isIdentifierPropSchema, isPropSchema} from '../utils/utils';

/**
 * Optional indicates that this property can be null.
 * Accepts a sub model schema to serialize the contents
 *
 * @example
 * class SubTask {}
 * class Task {}
 * class Todo {}
 *
 * createModelSchema(SubTask, {
 *     title: true,
 * });
 * createModelSchema(Todo, {
 *     title: true,
 *     subTask: optional(object(SubTask)),
 * });
 *
 * const todo = deserialize(Todo, {
 *     title: 'Task',
 *     subTask: null
 * });
 *
 * @param {IPropSchema} propSchema to be used to (de)serialize the content
 * @returns {IPropSchema}
 */
export function migrated(prevName:string, propSchema:PropSchema, converter?:DeserializeConverterFunc):IPropSchema
{
    invariant(prevName && typeof prevName === 'string', 'expected prop prevName as first argument');

    propSchema = (!propSchema || propSchema === true) ? _defaultPrimitiveProp : propSchema;

    invariant(isPropSchema(propSchema), 'expected prop schema as second argument');
    invariant(!isAliasedPropSchema(propSchema), 'provided prop is already aliased');

    return {
        prevname: prevName,
        converter: converter,
        serializer: propSchema.serializer,
        deserializer: propSchema.deserializer,
        identifier: isIdentifierPropSchema(propSchema)
    };
}
